import { render, staticRenderFns } from "./BdAdSet.vue?vue&type=template&id=1f132c68&scoped=true&"
import script from "./BdAdSet.vue?vue&type=script&lang=js&"
export * from "./BdAdSet.vue?vue&type=script&lang=js&"
import style0 from "./BdAdSet.vue?vue&type=style&index=0&id=1f132c68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f132c68",
  null
  
)

export default component.exports